export default __webpack_public_path__ + "static/media/loginImage.6b08ee1b.png";